export const customerKeys = {
  all: ["customers"] as const,
  list: (identity: string | null, options: object) =>
    ["customers", identity, "list", options] as const,
  identity: (identity: string | null, id: string | null) =>
    ["customers", identity, "identity", id] as const,
};
